'use es6';

const API_BASE = 'url-validation/v1';
export const apiPaths = {
  URL: `${API_BASE}/urls`
};